const getCompanyToken = () => {
    const url = new URL(window.location.href);
    const companyToken = url.searchParams.get("token");

    return companyToken
}

export default function useChatPlugin() {
    const getPluginConfig = () => {
        const companyToken = getCompanyToken()
        const webPluginConfig = JSON.parse(localStorage.getItem("webPluginConfig-" + companyToken))
        if (String(getPluginConfig).trim() === '') {
            return new Error("配置不存在~")
        }

        // console.log("webPluginConfig", webPluginConfig)
        // console.log("背景色", webPluginConfig.background_color)
        // console.log("按钮颜色", webPluginConfig.button_color)

        return {
            ...webPluginConfig,
            btnColor: webPluginConfig.button_color,
            bgColor: webPluginConfig.background_color,
        }
    }

    return {
        getPluginConfig
    }
}

export const getPluginConfig = () => {
    const companyToken = getCompanyToken()
    const webPluginConfig = JSON.parse(localStorage.getItem("webPluginConfig-" + companyToken))
    if (String(getPluginConfig).trim() === '') {
        return new Error("配置不存在~")
    }

    // console.log("webPluginConfig", webPluginConfig)
    // console.log("背景色", webPluginConfig.background_color)
    // console.log("按钮颜色", webPluginConfig.button_color)

    return {
        ...webPluginConfig,
        btnColor: webPluginConfig.button_color || "#0170fe",
        bgColor: webPluginConfig.background_color || "#0170fe",
    }
}
